import { render, staticRenderFns } from "./OVGListView.vue?vue&type=template&id=165b9ef0&scoped=true&lang=pug"
import script from "./OVGListView.vue?vue&type=script&lang=js"
export * from "./OVGListView.vue?vue&type=script&lang=js"
import style0 from "./OVGListView.vue?vue&type=style&index=0&id=165b9ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b9ef0",
  null
  
)

export default component.exports